<template>
  <div class="header-box" v-if="isShowSibber">
    <div v-for="item in products" :key="item.id">
      <div
        class="title"
        :class="{ 'title-left': item.showKey == 2 }"
        @click.stop="handleClickRoute(item)"
      >
        {{ item.name }}
      </div>
      <div
        :class="{
          'product-list': item.showKey != 2,
          'product-next': item.showKey == 2,
        }"
      >
        <div
          class="product-item"
          v-for="(product, index) in item.children"
          :key="index"
          @click.stop="handleClickRoute(product)"
        >
          {{ product.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductList",
  props: {
    isShowSibber: {
      type: Boolean,
      default: true,
    },
    products: {
      type: Array,
      default: () => [
        {
          name: "推荐产品",
          children: [
            { name: "WEB3钱包+IM", route: "/product" },
            { name: "DAO社区钱包", route: "/product" },
            { name: "天晟中心化交易所", route: "/product" },
            { name: "SE交易所", route: "/product" },
            { name: "烈焰WEB3去中心化钱包", route: "/product" },
            { name: "WEB3生态综合", route: "/product" },
          ],
        },
      ],
    },
  },
  data() {
    return {};
  },
  methods: {
    handleClickRoute({ route, id }) {
      if (
        (route && this.$route.path == route) ||
        typeof route !== "string" ||
        !route.includes("/")
      ) {
        this.$emit("updateShowSibber", false);
        return;
      }
      try {
        this.$router.replace({ path: route, query: { id } });
        this.$emit("updateShowSibber", false);
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header-box {
  width: fit-content;
  height: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  position: fixed;
  z-index: 999;
  background-color: #f8f9fa;
  top: 60px;
  left: 200px;
  padding: 0 20px;
}

.title {
  font-size: 18px;
  font-weight: 600;
  padding: 10px 0;
  cursor: pointer;
  text-align: center;
  margin-left: 20px;

  &:hover {
    color: #5a91f2;
  }
}

.product-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 0 20px;
}

.product-item {
  border-radius: 8px;
  padding: 10px 20px;
  color: black;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s;
  text-align: center;

  &:hover {
    color: #5a91f2;
    background-color: #f0f4ff;
  }
}

.product-next {
  width: 100%;
  display: flex;
  flex-direction: column;

  .product-item {
    max-width: 100%;
  }
}

.title-left {
  text-align: left;
  margin-left: 20px;
}
</style>
